import { Button, Card, Col, DatePicker, Descriptions, Form, Input, InputNumber, Modal, Row, Select, Table, Tabs } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { ColumnProps } from 'antd/lib/table';
import React from 'react';
import { BaleService } from '@gtpl/shared-services/raw-material-procurement'
import { BaleStatusEnum, BaleTypeEnum, QualityTypeEnum, RMInwardTypeEnum } from '@gtpl/shared-models/common-models';
import moment from 'moment';
import { BaleInfoReq, BaleItemReq, BaleReq, TabNameReq } from '@gtpl/shared-models/raw-material-procurement';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { useForm } from 'antd/lib/form/Form';
import printJS from "print-js";
import QRCode from "qrcode";
import { ProductService } from '@gtpl/shared-services/masters'
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { get } from 'http';
import { PackTypeCategory } from '@gtpl/shared-models/sale-management';

const { TabPane } = Tabs;
const { Option } = Select

export const BaleCreation = () => {
  const baleService = new BaleService()
  const [openTabInfo, setOpenTabInfo] = useState<any[]>([])
  const [closedTabInfo, setClosedTabInfo] = useState<any[]>([])
  const [page, setPage] = React.useState(1);
  const [form] = Form.useForm()
  const [selectedRows, setSelectedRows] = useState<any[]>([])
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const userName = JSON.parse(localStorage.getItem('username'));
  const [tabName, setTabName] = useState<string>('Open')
  const [filterForm] = Form.useForm()
  const [inwardNumber, setInwardNumber] = useState<any[]>([])
  const [voucherNumber, setVoucherNumber] = useState<any[]>([])
  const [agent, setAgent] = useState<any[]>([])
  const [baleNumber, setBaleNumber] = useState<any[]>([])
  const [createBaleDisable, setCreateBaleDisable] = useState<boolean>(true)
  const printRef = useRef(null);
  const [printData, setPrintData] = useState([]);
  const [variants, setVariants] = useState<any[]>([])
  const variantService = new ProductService()
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editForm] = Form.useForm();
  const [selectedBale, setSelectedBale] = useState<any>(null);
  const searchInput = useRef(null);


  useEffect(() => {
    getOpenTabInfo()
    getInwardNumberInfo()
    getVoucherNumberInfo()
    getAgentInfo()
    getVariants()
  }, [])

  useEffect(() => {
    if(JSON.parse(localStorage.getItem('tareWeight'))){
      form.setFieldsValue({'tareWeight' : Number(JSON.parse(localStorage.getItem('tareWeight')))})
    }
  },[])

  const getVariants = () => {

    variantService.getAllActiveProducts().then(res => {
      if (res.status) {
        setVariants(res.data)
      } else {
        setVariants([])
      }
    })
  }

  const getOpenTabInfo = () => {
    const req = new BaleInfoReq(null, null, null, null)
    if (filterForm.getFieldValue('inwardNumber') != undefined) {
      req.inwardNumber = filterForm.getFieldValue('inwardNumber')
    }
    if (filterForm.getFieldValue('voucherNumber') != undefined) {
      req.voucherNumber = filterForm.getFieldValue('voucherNumber')
    }
    if (filterForm.getFieldValue('agent') != undefined) {
      req.agent = filterForm.getFieldValue('agent')
    }
    baleService.getRmInwardInfo(req).then(res => {
      if (res.status) {
        setOpenTabInfo(res.data)
      } else {
        setOpenTabInfo([])
      }
    })
  }

  const getClosedTabInfo = () => {
    const req = new BaleInfoReq(null, null, null, null)
    if (filterForm.getFieldValue('inwardNumber') != undefined) {
      req.inwardNumber = filterForm.getFieldValue('inwardNumber')
    }
    if (filterForm.getFieldValue('voucherNumber') != undefined) {
      req.voucherNumber = filterForm.getFieldValue('voucherNumber')
    }
    if (filterForm.getFieldValue('agent') != undefined) {
      req.agent = filterForm.getFieldValue('agent')
    }
    if (filterForm.getFieldValue('baleNumber') != undefined) {
      req.baleNumber = filterForm.getFieldValue('baleNumber')
    }
    baleService.getBaleInfo(req).then(res => {
      if (res.status) {
        setClosedTabInfo(res.data)
      } else {
        setClosedTabInfo([])
      }
    })
  }

  const getInwardNumberInfo = () => {
    const req = new TabNameReq(tabName)
    baleService.getInwardNumberDropDownInfo(req).then(res => {
      if (res.status) {
        setInwardNumber(res.data)
      } else {
        setInwardNumber([])
      }
    })
  }

  const getVoucherNumberInfo = () => {
    const req = new TabNameReq(tabName)
    baleService.getVoucherNumberDropDownInfo(req).then(res => {
      if (res.status) {
        setVoucherNumber(res.data)
      } else {
        setVoucherNumber([])
      }
    })
  }

  const getAgentInfo = () => {
    const req = new TabNameReq(tabName)
    baleService.getAgentDropDownInfo(req).then(res => {
      if (res.status) {
        setAgent(res.data)
      } else {
        setAgent([])
      }
    })
  }

  const getBaleNumberInfo = () => {
    baleService.getBaleNumberDropDownInfo().then(res => {
      if (res.status) {
        setBaleNumber(res.data)
      } else {
        setBaleNumber([])
      }
    })
  }

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      ) : null
  });

  const openColumns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      align: 'left',
      responsive: ['md'],
      render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
      title: 'Inward Number',
      dataIndex: 'inwardNumber',
      sorter: (a, b) => a.inwardNumber.length - b.inwardNumber.length || a.inwardNumber.localeCompare(b.inwardNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('inwardNumber')
    },
    {
      title: 'Inward Type',
      dataIndex: 'inwardType',
      sorter: (a, b) => a.inwardType.length - b.inwardType.length || a.inwardType.localeCompare(b.inwardType),
      sortDirections: ['descend', 'ascend'],
      filters: Object.values(RMInwardTypeEnum).map(val => ({
        text: val,
        value: val
      })),
      filterMultiple: true,
      onFilter: (value, record) => {
        return record.inwardType == value;
      },
    },
    {
      title: 'Voucher Date',
      dataIndex: 'voucherDate',
      sorter: (a, b) => moment(a.voucherDate).unix() - moment(b.voucherDate).unix(),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('voucherDate'),
      render: (text, record) => {
        return (
          moment(record.voucherDate).format('DD-MM-YYYY')
        )
      }

    },
    {
      title: 'Voucher Number',
      dataIndex: 'voucherNumber',
      sorter: (a, b) => a.voucherNumber.length - b.voucherNumber.length || a.voucherNumber.localeCompare(b.voucherNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('voucherNumber')
    },
    {
      title: 'Agent',
      dataIndex: 'agent',
      sorter: (a, b) => a.agent.length - b.agent.length || a.agent.localeCompare(b.agent),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('agent')
    },
    {
      title: 'Variant',
      dataIndex: 'variant',
      sorter: (a, b) => a.variant.length - b.variant.length || a.variant.localeCompare(b.variant),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('variant')
    },
    {
      title: 'Quality',
      dataIndex: 'quality',
      sorter: (a, b) => a.quality.length - b.quality.length || a.quality.localeCompare(b.quality),
      sortDirections: ['descend', 'ascend'],
      filters: Object.values(QualityTypeEnum).map(val => ({
        text: val,
        value: val
      })),
      filterMultiple: true,
      onFilter: (value, record) => {
        return record.quality == value;
      },
    },
    {
      title: 'Package Type',
      dataIndex: 'packageType',
      sorter: (a, b) => a.packageType.length - b.packageType.length || a.packageType.localeCompare(b.packageType),
      sortDirections: ['descend', 'ascend'],
      filters: [
        { text: 'Boxes', value: 'Boxes' },
        { text: 'Bags', value: 'Bags' },
      ],
      filterMultiple: true,
      onFilter: (value, record) => {
        return record.packageType == value;
      },
    },
    {
      title: 'Inward Quantity',
      dataIndex: 'quantity',
      sorter: (a, b) => a.quantity - b.quantity,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        return (
          Number(record.quantity)
        )
      }
    },
    {
      title: 'Remaining Quantity',
      dataIndex: 'remainingQty',
      sorter: (a, b) => a.remainingQty - b.remainingQty,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        return (
          <>{Number(record.remainingQty)}</>
        )
      }
    },

    {
      title: 'Bale Quantity',
      dataIndex: 'baleQty',
      render: (text, record, index) => {
        return (
          tabName == 'Open' ? <InputNumber value={Number(record.baleQty) ?? Number(record.remainingQty)} onChange={(e) => onBaleQtyChange(e, index, record)} /> : Number(record.baleQty)
        )
      }
    },
    {
      title: 'Reporting Type',
      dataIndex: 'reportingType',
      render: (text, record, index) => {
        return (
          <Select optionFilterProp='children' allowClear showSearch value={record.reportingType ?? 'Partial'} onChange={(e) => { onReportingTypeChange(e, index,record) }} style={{ width: '100%' }}>
            <Option key='Full' value={'Full'}>Full</Option>
            <Option key='Partial' value={'Partial'}>Partial</Option>
          </Select>
        )
      }
    }
  ]

  const closedColumns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      align: 'left',
      responsive: ['md'],
      render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
      title: 'Bale Number',
      dataIndex: 'baleNumber',
      sorter: (a, b) => a.baleNumber.length - b.baleNumber.length || a.baleNumber.localeCompare(b.baleNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('baleNumber')
    },
    {
      title: 'Bale Date',
      dataIndex: 'baleDate',
      sorter: (a, b) => moment(a.baleDate).unix() - moment(b.baleDate).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        return (
          moment(record.baleDate).format('YYYY-MM-DD')
        )
      }
    },
    {
      title: 'Type',
      dataIndex: 'type',
      sorter: (a, b) => a.type.length - b.type.length || a.type.localeCompare(b.type),
      sortDirections: ['descend', 'ascend'],
      filters: Object.values(BaleTypeEnum).map(val => ({
        text: val,
        value: val
      })),
      filterMultiple: true,
      onFilter: (value, record) => {
        return record.type == value;
      },
    },
    {
      title: 'Variant',
      dataIndex: 'baleVariant',
      sorter: (a, b) => a.baleVariant.length - b.baleVariant.length || a.baleVariant.localeCompare(b.baleVariant),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('baleVariant'),
      render: (text, record) => {
        return (text ? text : '-')
      }
    },
    {
      title: 'Quality',
      dataIndex: 'baleQuality',
      sorter: (a, b) => a.baleQuality.length - b.baleQuality.length || a.baleQuality.localeCompare(b.baleQuality),
      sortDirections: ['descend', 'ascend'],
      filters: Object.values(QualityTypeEnum).map(val => ({
        text: val,
        value: val
      })),
      filterMultiple: true,
      onFilter: (value, record) => {
        return record.baleQuality == value;
      },
      render: (text, record) => {
        return (text ? text : '-')
      }
    },

    
    {
      title: 'Gross Quantity',
      dataIndex: 'grossWeight',
      sorter: (a, b) => a.grossWeight - b.grossWeight,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        return {
          children: Number(record.grossWeight)
        };
      }
    },
    {
      title: 'Tare Quantity',
      dataIndex: 'tareWeight',
      sorter: (a, b) => a.tareWeight - b.tareWeight,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        return {
          children: Number(record.tareWeight)
        };
      }
    },
    {
      title: 'Actual Bale Quantity',
      dataIndex: 'actualBaleQty',
      sorter: (a, b) => a.actualBaleQty - b.actualBaleQty,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        return {
          children: Number(record.actualBaleQty)
        };
      }
    },
    {
      title: 'Action',
      render: (_, record) => {
        return record.status === BaleStatusEnum.OPEN ? (
          <span
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(record);
            }}
          >
            <EditOutlined style={{ cursor: 'pointer', fontSize: '16px' }} />
          </span>
        ) : null;
      }
    }
    

  ]

  const itemsInfoColumns: ColumnProps<any>[] = [
    {
      title: 'Inward Number',
      dataIndex: 'inwardNumber',
      sorter: (a, b) => a.inwardNumber.length - b.inwardNumber.length || a.inwardNumber.localeCompare(b.inwardNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('inwardNumber')

    },
    {
      title: 'Voucher Number',
      dataIndex: 'voucherNumber',
      sorter: (a, b) => a.voucherNumber.length - b.voucherNumber.length || a.voucherNumber.localeCompare(b.voucherNumber),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('voucherNumber')
    },
    {
      title: 'Agent',
      dataIndex: 'agent',
      sorter: (a, b) => a.agent.length - b.agent.length || a.agent.localeCompare(b.agent),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('agent')
    },
    {
      title: 'Variant',
      dataIndex: 'variant',
      sorter: (a, b) => a.variant.length - b.variant.length || a.variant.localeCompare(b.variant),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('variant')
    },
    {
      title: 'Quality',
      dataIndex: 'quality',
      sorter: (a, b) => a.quality.length - b.quality.length || a.quality.localeCompare(b.quality),
      sortDirections: ['descend', 'ascend'],
      filters: Object.values(QualityTypeEnum).map(val => ({
        text: val,
        value: val
      })),
      filterMultiple: true,
      onFilter: (value, record) => {
        return record.quality == value;
      },
    },
    {
      title: 'Package Type',
      dataIndex: 'packageType',
      sorter: (a, b) => a.packageType.length - b.packageType.length || a.packageType.localeCompare(b.packageType),
      sortDirections: ['descend', 'ascend'],
      filters: [
        { text: 'Boxes', value: 'Boxes' },
        { text: 'Bags', value: 'Bags' },
      ],
      filterMultiple: true,
      onFilter: (value, record) => {
        return record.packageType == value;
      },
    },
    {
      title: 'Quantity',
      dataIndex: 'baleQty',
      sorter: (a, b) => a.baleQty - b.baleQty,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => {
        return (Number(Number(record.baleQty).toFixed(2)))
      }
    }
  ]

  const onReportingTypeChange = (e, index,record) => {
    const dataIndex = openTabInfo.findIndex(e => e.grnItemId == record.grnItemId)
    openTabInfo[dataIndex].reportingType = e
    setOpenTabInfo([...openTabInfo])
    const selectRowIndex = selectedRows.findIndex(e => e.grnItemId == record.grnItemId)
    if (selectRowIndex > -1) {
      selectedRows[selectRowIndex].reportingType = (e)
      setSelectedRows([...selectedRows])
    }
  }

  const onBaleQtyChange = (val, index, record) => {
    // if(val > record.baleQty){
    //   AlertMessages.getErrorMessage('Bale Quantity should not be greater than Remaining Quantity')
    // }
    const dataIndex = openTabInfo.findIndex(e => e.grnItemId == record.grnItemId)
    openTabInfo[dataIndex].baleQty = Number(val)
    setOpenTabInfo([...openTabInfo])
    const selectRowIndex = selectedRows.findIndex(e => e.grnItemId == record.grnItemId)
    if (selectRowIndex > -1) {
      selectedRows[selectRowIndex].baleQty = Number(val)
      setSelectedRows([...selectedRows])
    }
  }

  const onTabChange = (val) => {
    setTabName(val)
    filterForm.resetFields()
    setSelectedRows([])
    setSelectedRowKeys([]);
  }

  useEffect(() => {
    if (tabName == 'Open') {
      getOpenTabInfo()
      getInwardNumberInfo()
      getVoucherNumberInfo()
      getAgentInfo()
      getVariants()
    } else {
      getClosedTabInfo()
      getInwardNumberInfo()
      getVoucherNumberInfo()
      getAgentInfo()
      getBaleNumberInfo()
    }
  }, [tabName])

  const rowSelection = {
    selectedRowKeys,
    // preserveSelectedRowKeys: true, // ✅ keeps selection across pages
    onChange: (keys, rows) => {
      console.log(rows, '==============rows')
      setSelectedRowKeys(keys);
      setSelectedRows(rows);

      if (rows.length > 0) {
        setCreateBaleDisable(false);
      } else {
        setCreateBaleDisable(true);
      }
    },
  };

  const onCreateBale = (val) => {
    let totQty = 0
    const itemsInfo = []
    // const saveFlag = new Set<boolean>()
    // let selectedBaleQty = 0
    for (const rec of selectedRows) {
      // if (rec.remainingQty < rec.baleQty) {
      //   saveFlag.add(false)
      // }
      totQty += Number(rec.baleQty)
      itemsInfo.push(new BaleItemReq(rec.agentId, rec.quality, rec.baleQty, rec.voucherNumber, rec.grnItemId, rec.variantId, rec.reportingType,rec.inwardPrice))
    }
    // console.log(totQty)
    const req = new BaleReq(val.date, val.type, itemsInfo, totQty, userName, selectedRows[0].plantId, val.actualBaleQuantity, val.variant, val.quality, val.tareWeight,val.grossQuantity)
    // if (!(saveFlag.has(false))) {
      // console.log(req,'====req')
      baleService.createBale(req).then(res => {
        if (res.status) {
          AlertMessages.getSuccessMessage(res.internalMessage)
          // window.location.reload()
          setSelectedRows([])
          setSelectedRowKeys([])
          form.setFieldsValue({ 'type': undefined,grossQuantity : undefined,actualBaleQuantity : undefined })
          // setOpenTabInfo([])
          getOpenTabInfo()
          getVariants()
        } else {
          AlertMessages.getErrorMessage(res.internalMessage)
        }
      })
    // } 
    // else {
    //   AlertMessages.getErrorMessage('Entered Bale Quantity must be less than Remaining Inward Quantity')
    // }

  }

  const onReset = () => {
    filterForm.resetFields()
    if (tabName == 'Open') {
      getOpenTabInfo()
      getVariants()
    } else {
      getClosedTabInfo()
    }
  }

  const onSearch = () => {
    if (tabName == 'Open') {
      getOpenTabInfo()
    } else {
      getClosedTabInfo()
    }
  }

  const groupByBale = (data: any[]): any[] => {
    const grouped: Record<string, any> = {};

    data.forEach((item) => {
      if (!grouped[item.baleNumber]) {
        grouped[item.baleNumber] = {
          baleNumber: item.baleNumber,
          baleDate: item.baleDate,
          type: item.type,
          items: [],
        };
      }

      grouped[item.baleNumber].items.push({
        agent: item.agent,
        quality: item.quality,
        baleQty: item.baleQty,
      });
    });

    return Object.values(grouped);
  };
  // <div class="right">
  //   <img src="${qrCode}" class="qr"/>
  // </div>
  const onPrint = async () => {
    if (!selectedRows || selectedRows.length === 0) {
      AlertMessages.getErrorMessage("Please select at least one bale");
      return;
    }

    // const groupedData = groupByBale(selectedRows as any[]);
    const groupedData = selectedRows;

    let html = "";

    for (const bale of groupedData) {
      const qrValue = `${bale.baleNumber}`;
      const qrCode = await QRCode.toDataURL(qrValue);
      const d = new Date(bale.baleDate || bale.baleDate);
      const formattedDate = `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
      html += `
      <div class="bale">
        <div class="header">
          <div class="title2">SPSA SILKS PVT LTD</div>
          <div class="title">Bale: ${bale.baleNumber}</div>
        </div>

        <div class="top-row">
          <div class="left">
            <div>Date: ${formattedDate}</div>
            <div>Type: ${bale.type}</div>
          </div>
          <div class="right1">
            <div>Variant: ${bale.baleVariant || "-"}</div>
          </div>
        </div>

        <hr/>

        <table class="table">
          <thead>
            <tr>
              
              <th>Quality</th>
              <th> Gross Weight</th>
              <th>Tare Weight</th>
              <th>Net Weight</th>
            </tr>
          </thead>
          <tbody>
            <tr>
  <td>${bale.baleQuality || "-"}</td>
  <td class="qty"> ${Number(Number(bale.grossWeight || 0).toFixed(2))}</td>
<td class="qty">${Number(Number(bale.tareWeight || 0).toFixed(2))}</td>
<td class="qty">${Number(Number(bale.actualBaleQty || 0).toFixed(2))}</td>
</tr>
          </tbody>
        </table>
      </div>
    `;
    }

    printJS({
      printable: html,
      type: "raw-html",
      showModal: true,
      modalMessage: "Preparing Bale Print...",
      style: `
      @page {
        size: 80mm 40mm;
        margin: 0;
      }

      body {
        margin: 0;
        font-family: Arial;
      }

      .bale {
        width: 80mm;
        height: 40mm;
        padding: 3mm;
        box-sizing: border-box;
        page-break-after: always;
      }

      .title {
        font-weight: bold;
        font-size: 14px;
        text-align: center;
        margin-bottom: 2px;
      }
        .title2 {
        font-weight: bold;
        font-size: 14px;
        text-align: center;
        margin-bottom: 5px;
      }

      .top-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 11px;
        margin-bottom: 10px;
      }

      .left {
        display: flex;
        flex-direction: column;
        gap: 2px;
      }

      .right {
        display: flex;
        align-items: center;
      }

      .right1 {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-right: 30px;   
      }

      .qr {
        width: 40px;
        height: 40px;
      }

      hr {
        margin:0px;
        
      }

      .table {
        width: 100%;
        border-collapse: collapse;
        font-size: 10px;
        
      }

      .table th {
        text-align: left;
        border-bottom: 1px solid #000;
        padding-bottom: 2px;
        
      }

      .table td {
        padding: 1px 0;
      }

      
    `,
    });
  };

  useEffect(() => {
    // let actualQty = 0
    // console.log(selectedRows)
    // for (const rec of selectedRows) {
    //   actualQty += Number(rec.baleQty)
    // }
    // form.setFieldsValue({ 'actualBaleQuantity': actualQty })

    const combinations = new Set(
      selectedRows.map(item => `${item.variant}_${item.quality}`)
    );
    const variant = combinations.size === 1 ? selectedRows[0].variantId : undefined;
    const quality = combinations.size === 1 ? selectedRows[0].quality : undefined;
    form.setFieldsValue({ 'variant': variant, 'quality': quality })

    // ✅ Autofill baleQty when only one row is selected
      if (selectedRows.length === 1 && Number(form.getFieldValue('actualBaleQuantity')) > 0 && Number(selectedRows[0].baleQty) == Number(selectedRows[0].remainingQty) ) {
        const actualQty = Number(form.getFieldValue('actualBaleQuantity')) || 0;

        const updatedData = openTabInfo.map(item => {
          if (item.grnItemId === selectedRows[0].grnItemId) {
            return {
              ...item,
              baleQty: actualQty,
            };
          }
            return item;
          });

          setOpenTabInfo(updatedData);

          const updatedSelected = selectedRows.map(item =>
          item.grnItemId === selectedRows[0].grnItemId
            ? { ...item, baleQty: actualQty }
            : item
        );

        setSelectedRows(updatedSelected);
      }

  }, [selectedRowKeys])

  const handleEdit = (record: any) => {
  setSelectedBale(record);

  editForm.setFieldsValue({
    grossWeight: record.grossWeight,
    tareWeight: record.tareWeight,
    actualBaleQty: Number(record.actualBaleQty),
    date: moment()
  });

  setIsEditModalVisible(true);
};

  const handleUpdateActualQty = async () => {
    try {
      const values = await editForm.validateFields();

      const payload = {
        baleNumber: selectedBale.baleNumber,
        baleId: selectedBale.baleId,
        actualBaleQty: values.actualBaleQty,
        date:values.date.toISOString()

      };

      const res = await baleService.updateActualBaleQty(payload);

      if (res.status) {
        AlertMessages.getSuccessMessage("Updated Successfully");
        setIsEditModalVisible(false);
        editForm.resetFields()
        getClosedTabInfo(); // refresh table
      } else {
        AlertMessages.getErrorMessage(res.internalMessage);
      }
    } catch (err) { }
  };

  const onGrossQtyChange = (e) => {
    console.log(form.getFieldValue('tareWeight') ,'00',e)
    if(form.getFieldValue('tareWeight') != undefined){
      form.setFieldsValue({actualBaleQuantity : Number(e.target.value) - Number(form.getFieldValue('tareWeight'))})
        if (selectedRows.length === 1) {
        const updated = openTabInfo.map(item =>
          item.grnItemId === selectedRows[0].grnItemId
            ? { ...item, baleQty:  Number(e) - Number(form.getFieldValue('tareWeight'))}
            : item
        );
        setOpenTabInfo(updated);
      }
    }
  }

  const onTareQtyChange = (e) => {
    localStorage.setItem('tareWeight' , JSON.stringify(Number(e)))
    if(form.getFieldValue('grossQuantity') != undefined){
      form.setFieldsValue({actualBaleQuantity : Number(form.getFieldValue('grossQuantity')) - Number(e)})
       if (selectedRows.length === 1) {
        const updated = openTabInfo.map(item =>
          item.grnItemId === selectedRows[0].grnItemId
            ? { ...item, baleQty: Number(form.getFieldValue('grossQuantity')) - Number(e)}
            : item
        );
        setOpenTabInfo(updated);
      }
    }
  }

  return (
    <>
     <style>
    {`
      .child-table .ant-table-thead > tr > th {
        background-color: #f0f5ff !important;
        color: #000;
        font-weight: 500;
      }
    `}
  </style>
      <Card title={<span style={{ color: 'white' }}>Bale Generation</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
        extra={
          <>
            {tabName === 'Closed' && selectedRows.length > 0 && (
              <Button
                type="primary"
                onClick={onPrint}
                style={{ marginRight: '10px' }}
              >
                Print
              </Button>
            )}
          </>
        }
      >
        <Form form={filterForm} layout='vertical'>
          <Row gutter={[16, 16]}>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
              <Form.Item label='Inward Number' name='inwardNumber'>
                <Select allowClear showSearch optionFilterProp='children' placeholder='Select Inward Number' mode='multiple'>
                  {
                    inwardNumber.map(e => {
                      return (
                        <Option key={e.inwardNumber} value={e.inwardNumber}>{e.inwardNumber}</Option>
                      )
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
              <Form.Item label='Voucher Number' name='voucherNumber'>
                <Select allowClear showSearch optionFilterProp='children' placeholder='Select Voucher Number' mode='multiple'>
                  {
                    voucherNumber.map(e => {
                      return (
                        <Option key={e.voucherNumber} value={e.voucherNumber}>{e.voucherNumber}</Option>
                      )
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 6 }}>

              <Form.Item label='Agent' name='agent'>
                <Select allowClear showSearch optionFilterProp='children' placeholder='Select Agent' mode='multiple'>
                  {
                    agent.map(e => {
                      return (
                        <Option key={e.agentId} value={e.agentId}>{e.agent}</Option>
                      )
                    })
                  }
                </Select>
              </Form.Item>
            </Col>
            {
              tabName == 'Open' ? (<></>) : (<>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                  <Form.Item label='Bale Number' name='baleNumber'>
                    <Select allowClear showSearch optionFilterProp='children' placeholder='Select Bale Number' mode='multiple'>
                      {
                        baleNumber.map(e => {
                          return (
                            <Option key={e.baleNumber} value={e.baleNumber}>{e.baleNumber}</Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </>)
            }
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }} style={{ marginTop: '2%' }}>
              <Form.Item>
                <Button type='primary' onClick={onSearch}>Search</Button>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }} style={{ marginTop: '2%' }}>
              <Form.Item>
                <Button danger onClick={onReset}>Reset</Button>
              </Form.Item>
            </Col>
          </Row>

        </Form>
        <Tabs onChange={onTabChange}>
          <TabPane key='Open' tab='OPEN'>
            <Form form={form} initialValues={{ date: moment() }} onFinish={onCreateBale} layout='vertical'>
              <Form.Item hidden name='quality'>
                <Input />
              </Form.Item>
              <Row gutter={24}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 3 }}>
                  <Form.Item label={'Date'} name='date' rules={[{ required: true, message: 'Date is required' }]}>
                    <DatePicker style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 3 }}>
                  <Form.Item label={'Type'} name='type' rules={[{ required: true, message: 'Type is required' }]}>
                    <Select allowClear showSearch optionFilterProp='children' placeholder='Select Type'>
                      {
                        Object.values(BaleTypeEnum).map(e => {
                          return (
                            <Option key={e} value={e}>{e}</Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 3 }}>
                      <Form.Item label='Gross Quantity' name='grossQuantity' rules={[
                        {required:true,message:'Gross Quantity is required'},
                        {
                      validator: (_, value) => {
                        if (Number(value) <= 0) {
                          return Promise.reject('Gross Quantity should be greater than 0');
                        }
                        return Promise.resolve();
                      }}
                      ]}>
                        <Input onBlur={onGrossQtyChange} placeholder='Enter Gross Quantity'/>
                      </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 3 }}>
                  <Form.Item label={'Tare Quantity'} name='tareWeight' rules={[
                    { required: true, message: 'Tare Quantity is required' },
                    {
                      validator: (_, value) => {
                        if (Number(value) <= 0) {
                          return Promise.reject('Tare Quantity should be greater than 0');
                        }
                        return Promise.resolve();
                      }
                    }]}

                  >
                    {/* <Input placeholder='Enter Tare Quantity' /> */}
                    <Select allowClear showSearch optionFilterProp='children' placeholder='Select Tare Quantity' onChange={onTareQtyChange}>
                      <Option key='0.2' value='0.2'>0.2</Option>
                      <Option key='0.3' value='0.3'>0.3</Option>
                      <Option key='0.4' value='0.4'>0.4</Option>
                      <Option key='0.5' value='0.5'>0.5</Option>
                      <Option key='0.8' value='0.8'>0.8</Option>
                      <Option key='1' value='1'>1</Option>
                      <Option key='1.1' value='1.1'>1.1</Option>
                      <Option key='1.2' value='1.2'>1.2</Option>
                      <Option key='1.5' value='1.5'>1.5</Option>
                      <Option key='1.6' value='1.6'>1.6</Option>
                      <Option key='1.8' value='1.8'>1.8</Option>
                      <Option key='2' value='2'>2</Option>
                      <Option key='2.2' value='2.2'>2.2</Option>
                      <Option key='2.5' value='2.5'>2.5</Option>
                      <Option key='2.6' value='2.6'>2.6</Option>
                      <Option key='2.8' value='2.8'>2.8</Option>
                      <Option key='3' value='3'>3</Option>
                      <Option key='3.5' value='3.5'>3.5</Option>
                      <Option key='4' value='4'>4</Option>
                      <Option key='4.5' value='4.5'>4.5</Option>
                      <Option key='4.8' value='4.8'>4.8</Option>
                      <Option key='5' value='5'>5</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 3 }}>
                  <Form.Item label={'Actual Bale Quantity'} name='actualBaleQuantity' rules={[{ required: true, message: 'Actual Bale Quantity is required' }]} >
                    <Input placeholder='Enter Actual Bale Quantity' disabled/>
                  </Form.Item>
                </Col>
                
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                  <Form.Item label={'Variant'} name='variant' rules={[{ required: true, message: 'Variant is required' }]}>
                    {/* <Input placeholder='Enter Variant'/> */}
                    <Select allowClear showSearch optionFilterProp='children' placeholder='Select Variant'>
                      {
                        variants.map(e => {
                          return (
                            <Option key={e.productId} value={e.productId}>{e.productName}</Option>
                          )
                        })
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} style={{ marginTop: '1.5%' }}>
                  <Form.Item>
                    <Button type='primary' htmlType='submit' disabled={createBaleDisable}>Create Bale</Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Table columns={openColumns} dataSource={openTabInfo} rowKey={(record) => record.grnItemId}
              rowSelection={{
                ...rowSelection
              }} size='small'
              pagination={{
                pageSize: 10,
                onChange(current, pageSize) {
                  setPage(current);
                  // setPageSize(pageSize);
                }
              }}
            />
          </TabPane>
          <TabPane key='Closed' tab='CLOSED'>
            <Table columns={closedColumns} dataSource={closedTabInfo} rowKey={(record) => record.baleNumber}
              rowSelection={{
                ...rowSelection
              }}
              pagination={{
                pageSize: 10,
                onChange(current, pageSize) {
                  setPage(current);
                  // setPageSize(pageSize);
                }
              }}
              expandable={{
                expandedRowRender: (record) => (
                   <div style={{ padding: '12px 24px', background: '#fafafa' }}>
                    <Table
                    className="child-table"
                      columns={itemsInfoColumns}
                      dataSource={record.itemsInfo}
                      pagination={false}
                      size="small"
                    />
                  </div>
                ),
                expandIconColumnIndex: closedColumns.length + 1,
              }}
              size='small'
            />
          </TabPane>
        </Tabs>
      </Card>
      <Modal
  title="Edit Actual Bale Quantity"
  visible={isEditModalVisible}
  onCancel={() => {setIsEditModalVisible(false) , editForm.resetFields()}}
  onOk={handleUpdateActualQty}
  okText="Update"
  cancelText="Cancel"
>
  <Descriptions bordered size="small" column={1}>
    <Descriptions.Item label="Bale Number">
      {selectedBale?.baleNumber}
    </Descriptions.Item>

    <Descriptions.Item label="Bale Date">
      {selectedBale?.baleDate
        ? moment(selectedBale.baleDate).format('YYYY-MM-DD')
        : '-'}
    </Descriptions.Item>

    <Descriptions.Item label="Variant">
      {selectedBale?.baleVariant || '-'}
    </Descriptions.Item>
  </Descriptions>

  <br />

  <Form form={editForm} layout="vertical">
    <Form.Item label="Gross Quantity" name="grossWeight">
      <Input disabled />
    </Form.Item>

    <Form.Item label="Tare Quantity" name="tareWeight">
      <Input disabled />
    </Form.Item>
    <Form.Item label='Date' name='date' rules={[{ required: true, message: 'Date is required' }]}>
      <DatePicker style={{ width: '100%' }}  />
    </Form.Item>
    <Form.Item
      name="actualBaleQty"
      label="Actual Bale Quantity"
      rules={[
        { required: true, message: 'Please enter quantity' },
        {
          validator: (_, value) => {
            if (Number(value) <= 0) {
              return Promise.reject('Must be greater than 0');
            }
            return Promise.resolve();
          }
        }
      ]}
    >
      <Input />
    </Form.Item>
  </Form>
</Modal>

    </>
  )

}

export default BaleCreation